'use strict'

import ServiceExec from "@/common/utils/ServiceExec"

class PublicReportSvc extends ServiceExec {
  getMonthlySummary(params = {}) {
    return this.queryPost(`/api/public/report/getMonthlySummary`, params)
      .then(res => res.data)
  }
}

export default new PublicReportSvc()
